import React from 'react';

import useDocumentIntroductionTextModal from '@HOOKS/store/modals/useDocumentIntroductionTextModal';
import { useUpdateDocumentIntroductionText } from '@SERVICES';

import IntroductionTextModal from '@MODALS/IntroductionTextModal';

function DocumentIntroductionTextModal() {
    const {
        state: { data: modalParams, isOpen },
        actions: documentIntroductionTextModalActions,
    } = useDocumentIntroductionTextModal(() => true);

    const [
        updateDocumentIntroductionText,
        {
            isLoading: isSaving,
            isSuccess: isSaveSuccess,
            isError: isSaveError,
        },
    ] = useUpdateDocumentIntroductionText();

    if (!modalParams) return null;

    const { documentData, canEditDocument } = modalParams;

    const handleSave = (content: string) => {
        updateDocumentIntroductionText({
            id: documentData.id,
            body: content,
        });
    };

    const handleClose = () => {
        documentIntroductionTextModalActions.close();
    };

    const config = {
        title: 'Document Introduction Text',
        subtitle: 'This text will appear above the table of contents',
        successMessage: 'Document introduction text saved successfully',
        errorMessage: 'Failed to save document introduction text',
    };

    return (
        <IntroductionTextModal
            isOpen={isOpen}
            onClose={handleClose}
            initialValue={documentData.introduction_text?.body || ''}
            canEdit={canEditDocument}
            config={config}
            onSave={handleSave}
            isSaving={isSaving}
            saveError={isSaveError}
            saveSuccess={isSaveSuccess}
        />
    );
}

export default DocumentIntroductionTextModal; 